<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero __full-screen"
      appBackgroundBranded>
      <div class="landing_hero_main">
        <form
          class="fb-panel"
          [formGroup]="companyForm"
          (ngSubmit)="validateCompany()"
          novalidate>
          <ic-logo class="fb-panel_logo"></ic-logo>

          <h2 class="fb-panel_title">{{ t('auth.login.sign-in') }}</h2>

          <div
            class="fb-panel_row"
            style="margin-bottom: 8px">
            <label for="domain">{{ t('auth.login.enter-company-domain') }}</label>
          </div>

          <div class="fb-panel_row">
            <app-domain-input
              mode="subdomain"
              controlClasses="__height-l"
              formControlName="domainName"
              [markAsDirty]="isSubmitted"></app-domain-input>
          </div>

          <!--Send button and confirmation-->
          <div class="fb-panel_row __large">
            <button
              type="submit"
              class="btn __block __l"
              [disabled]="isInProgress"
              ngPreserveWhitespaces>
              <i
                class="spinner"
                *ngIf="isInProgress"></i>
              {{ t('auth.login.continue') }}
            </button>
          </div>

          <div
            [appAnimateEvent]="animate"
            animateEventClass="shake">
            <span>{{ t('auth.login.forgot-domain') }}</span
            >&nbsp;<a
              class="link"
              uiSref="find-company"
              >{{ t('auth.login.remind-me') }}</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
